import React from 'react'
import MapPin from 'src/components/icons/ui/MapPin'

interface ILocationItemProps {
  address: string
  type: 'dropOff' | 'pickUp'
}

const LocationItem = ({ address, type }: ILocationItemProps) => (
  <div className='column-gap-12 flex items-center rp-mt8'>
    <div className='icon--20x20'>
      <MapPin className={`icon--20x20 ${type === 'pickUp' ? 'svg-color-green1' : 'svg-color-red1'}`} />
    </div>
    <div>
      <p className='font-black3 mt0 rp-mb0 text-md'>{address}</p>
    </div>
  </div>
)

export default LocationItem



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/LocationItem.tsx